export const calculateYearsSinceSale = (saleTimestamp) => {
  const saleDate = new Date(saleTimestamp);
  const currentDate = new Date();
  const yearDiff = currentDate.getFullYear() - saleDate.getFullYear();
  const monthDiff = currentDate.getMonth() - saleDate.getMonth();
  return yearDiff + monthDiff / 12;
};

export const getGrowthRate = ({
  propertyChartData,
  chartData,
  housePriceData,
  regional = false,
}) => {
  let annualGrowthRate;
  if (!regional) {
    if (
      propertyChartData.sameTypeStats &&
      propertyChartData.sameTypeStats.count > 10 &&
      propertyChartData.sameTypeStats.annualIncrease !== undefined &&
      propertyChartData.sameTypeStats.annualIncrease !== null &&
      !isNaN(propertyChartData.sameTypeStats.annualIncrease)
    ) {
      annualGrowthRate = propertyChartData.sameTypeStats.annualIncrease / 100;
    } else if (chartData && Array.isArray(chartData.series)) {
      const currentTypeStr = (propertyChartData.currentPropertyType || '').toLowerCase();
      const propertyTypeNormalized = {
        detached: ['detached', 'd'],
        'semi-detached': ['semi-detached', 'semi', 's'],
        terraced: ['terraced', 'terrace', 't'],
        flat: ['flat', 'maisonette', 'apartment', 'f'],
      };
      const matchingTypes = Object.keys(propertyTypeNormalized).filter((type) =>
        propertyTypeNormalized[type].some(
          (alias) => currentTypeStr.includes(alias) || alias === currentTypeStr,
        ),
      );
      const matchingSeries = chartData.series.find((series) => {
        if (!series.name) return false;
        const seriesName = series.name.toLowerCase();
        if (seriesName.includes(currentTypeStr) || currentTypeStr.includes(seriesName)) return true;
        return matchingTypes.some((type) =>
          propertyTypeNormalized[type].some((alias) => seriesName.includes(alias)),
        );
      });
      if (
        matchingSeries &&
        matchingSeries.stat &&
        matchingSeries.stat.annualIncrease !== undefined &&
        matchingSeries.stat.annualIncrease !== null &&
        !isNaN(matchingSeries.stat.annualIncrease)
      ) {
        annualGrowthRate = matchingSeries.stat.annualIncrease / 100;
      }
    }
  }
  if (
    !annualGrowthRate &&
    housePriceData &&
    housePriceData.regionPriceIndex &&
    housePriceData.regionPriceIndex.increases
  ) {
    if (housePriceData.regionPriceIndex.increases.byType && propertyChartData.currentPropertyType) {
      if (housePriceData.regionPriceIndex.increases.byType[propertyChartData.currentPropertyType]) {
        annualGrowthRate =
          housePriceData.regionPriceIndex.increases.byType[propertyChartData.currentPropertyType]
            .annualized / 100;
      } else {
        const propertyTypeMap = {
          detached: 'detached',
          'semi-detached': 'semi-detached',
          terraced: 'terraced',
          flat: 'flat',
          maisonette: 'flat',
        };
        const normalizedType = propertyChartData.currentPropertyType.toLowerCase();
        let matchedType = null;
        for (const [typeKey, mappedType] of Object.entries(propertyTypeMap)) {
          if (normalizedType.includes(typeKey)) {
            matchedType = mappedType;
            break;
          }
        }
        if (matchedType && housePriceData.regionPriceIndex.increases.byType[matchedType]) {
          annualGrowthRate =
            housePriceData.regionPriceIndex.increases.byType[matchedType].annualized / 100;
        } else if (housePriceData.regionPriceIndex.increases.overall) {
          annualGrowthRate = housePriceData.regionPriceIndex.increases.overall.annualized / 100;
        }
      }
    }
  }
  return annualGrowthRate;
};
